import { Grid } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetPaymentMethodV2 } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SavePaymentMethodV2 } from '../../shared/components';

export type UpdatePaymentMethodV2PageProps = {};

const UpdatePaymentMethodV2Page: React.FC<UpdatePaymentMethodV2PageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_formapago);
  const returnUrlPaymentMethodsPage =
    ROUTER_PATHS.administration.metodoPagoNav;
  const { id } = useParams();
  const { data, isLoading } = useGetPaymentMethodV2(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_formapago_v2)
    return <Navigate to={returnUrlPaymentMethodsPage} />;

  return (
    <Grid container spacing={2} padding="24px">
      <SavePaymentMethodV2
        titlePage="Editar Método de Pago V2"
        editPaymentMethod={data.data}
      />
    </Grid>
  );
};

export default UpdatePaymentMethodV2Page;
